import { OnInit, OnDestroy, Component, Inject, Optional, HostListener  } from '@angular/core';
import { IContextService} from '@pershing/pershing-core';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { ActivatedRoute, Router } from '@angular/router';

declare let dojoApp: any;

@Component({
    selector: 'dojo-DA-Mixin',
    templateUrl: './dojo-digital-advice-mixin.component.html'
})
export class DojoDAMixinComponent implements OnInit, OnDestroy {

    qaInternalUrl: string;
    cdnUrl: any;
    widgetsVersion: any;
    programCode: string;
    offCode: string;

    constructor(private paramService: NxiWidgetParamsService, private nxiRestService: NxiRestService,
                @Optional() @Inject('AppSettings') appSettings: any , private route: ActivatedRoute,
                private router: Router, private contextService: IContextService) {
            this.qaInternalUrl = this.nxiRestService.serviceUrl;
            this.cdnUrl = appSettings.ibdConfigMap.cdnURL;
            this.widgetsVersion = appSettings.ibdConfigMap.widgets_version;
            console.log('appSettings -->', 'cdnUrl', this.cdnUrl, 'widgetsVersion' , this.widgetsVersion);
    }

    getWidgetResponse(): any {
        if (this.contextService.getRouteContext instanceof Function) {
            let routeContext = this.contextService.getRouteContext();
            routeContext = this.convertRouteContextStringToObj(routeContext);
            this.offCode= !!routeContext && routeContext.offcode == 'T9H' ? 'T9H': '';
        }
        this.paramService.getWidgetParamsForMixin('digitalAdviseMixin').subscribe(
      resp => {
        let response: any = resp.response;
        resp.response.resourceUrl = this.qaInternalUrl + resp.response.resourceUrl;
        console.log('response', response);
        if(this.programCode){
            response['progCode'] = this.programCode;
        }
        if(this.offCode){
            response['offcode'] = this.offCode;
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.renderDAMixinPage(response, this.cdnUrl, this.widgetsVersion);
        }
      },
     error => {
         console.log('error', error);
         return error;
      }
    );
  }
  convertRouteContextStringToObj(routeContext) {
    if (!!routeContext && typeof routeContext === 'string') {
      const result = {};
      routeContext = new URLSearchParams(routeContext);
      for (const [key, value] of routeContext) {
        result[key] = value;
      }
      routeContext = result;
    }
    return routeContext;
  }

    ngOnInit() {
          window.scrollTo(0,0);
          this.getWidgetResponse() ;
          this.programCode =  this.route.snapshot.queryParams['progCode'];
    }

    ngOnDestroy(): void {
        console.log('In DojoMixinComponent destroy method');
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyDAMixinPage();
        }
    }
    @HostListener('window:navaigateToAccountOpening' , ['$event'])
    onNavigateToAccountOpening(event:any) {
        if(event.detail){
            this.router.navigate([event.detail.goTo], {
                queryParams : event.detail.reqParams
            })
        }   
    }
}
